import { qs } from '../dom-helpers';
import Abstract from './class.Abstract';

class Recipe {
  constructor() {

    this._resizeYouTubeVideo();
    window.addEventListener('resize', () => this._resizeYouTubeVideo());

    if (!qs('.single-recipe__video')) return;

    this.video = qs('.single-recipe__video');
    this.playButton = qs('.play-image-container');
    this._run();
  }

  _run() {
    this._initEventListeners();
  }

  _initEventListeners() {
    this.playButton.addEventListener('click', () => this._handleCustomPlayButton());
    this.video.addEventListener('play', () => this._hidePlayButton());
    this.video.addEventListener('pause', () => this._showPlayButton());
  }

  _handleCustomPlayButton() {
    this.video.play();
  }

  _showPlayButton() {
    Abstract.fadeIn(this.playButton);
  }

  _hidePlayButton() {
    Abstract.fadeOut(this.playButton);
  }

  _resizeYouTubeVideo() {
    jQuery('iframe[src*="youtube.com"]').each(function(i, e) {
        var container = jQuery(e).parent();
        e.width = container.width();
        e.height = container.width() / 16 * 9
    });
  }
}

export default Recipe;
